
import { participantInstance } from "./api";
const url = process.env.REACT_APP_BASE_URL || "/";

//call the api for get details and questions of an inventory by passing its Id
async function getInventoryDetails(inventory_id) {
  const api =
    url +
    `/participants/inventories/${inventory_id}/details`;

  return await participantInstance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}
  // call the api for add inventory answer
async function addInventoryAnswer(inventory_id, data) {
  const api =
    url +
    `/participants/inventories/${inventory_id}/responses`;

  return await participantInstance
    .post(api, data)
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response;
    });
}

 // call the api for getting the result of an inventory
async function getInventoryAnswer(inventory_id) {
  const api =
    url +
    `/participants/inventories/${inventory_id}/scores`;

  return await participantInstance
    .get(api)
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response;
    });
}

//call the api for get details and questions of an evaluation by passing workshop_id
async function getEvaluationDetails(workshop_id) {
  const api =
    url +
    `/participants/evaluations/${workshop_id}/details`;

  return await participantInstance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

  // call the api for add inventory answer
  async function addEvaluationAnswer(workshop_id, data) {
    const api =
      url +
      `/participants/evaluations/${workshop_id}/responses`;
  
    return await participantInstance
      .post(api, data)
      .then((response) => {
        //retun status 1 for success
        return response;
      })
      .catch((error) => {
        //return error
        return error.response;
      });
  }

  // call the api for getting the result of an Evaluation
async function getEvaluationAnswer(workshop_id) {
  const api =
    url +
    `/participants/evaluations/${workshop_id}/responses`;

  return await participantInstance
    .get(api)
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response;
    });
}

//call the api for get details and questions of an evaluation by passing workshop_id
async function getFollowupDetails(followup_id) {
  const api =
    url +
    `/participants/followups/${followup_id}/details`;

  return await participantInstance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

 // call the api for add inventory answer
 async function addFollowupAnswer(followup_id, data) {
  const api =
    url +
    `/participants/followups/${followup_id}/responses`;

  return await participantInstance
    .post(api, data)
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response;
    });
}

async function getFollowupAnswer(followup_id) {
  const api =
    url +
    `/participants/followups/${followup_id}/responses`;

  return await participantInstance
    .get(api)
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response;
    });
}

async function addInventorySteps(inventory_id, data) {
  const api =
    url +
    `/participants/inventories/${inventory_id}/step`;

  return await participantInstance
    .post(api, data)
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response;
    });
}

async function updateInventorychecklist(inventory_id, data) {
  const api =
    url +
    `/participants/inventories/${inventory_id}/checklist`;

  return await participantInstance
    .post(api, data)
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response;
    });
}

async function getInventorychecklist(inventory_id, data) {
  const api =
    url +
    `/participants/inventories/${inventory_id}/checklist-answers`;

  return await participantInstance
    .post(api, data)
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response;
    });
}

async function PostResponseLogs(data) {
  const api =
    url +
    `/participants/answer-logs`;

  return await participantInstance
    .post(api, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

async function addInventoryPartialAnswers(inventory_id, data) {
  const api =
    url +
    `/participants/inventories/${inventory_id}/answer-save`;

  return await participantInstance
    .post(api, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

async function getInventoryPartialAnswers(inventory_id) {
  const api =
    url +
    `/participants/inventories/${inventory_id}/answer`;

  return await participantInstance
    .get(api)
    .then((response) => {
      return response;
     
    })
    .catch((error) => {
      return error.response;
    });
}

  // call the api for add Evaluation Partial answer
  async function addEvaluationPartialAnswer(workshop_id, data) {
    const api =
      url +
      `/participants/evaluations/${workshop_id}/answer-save`;
  
    return await participantInstance
      .post(api, data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  }

  //api for getting Evaluation Partial answeres
  async function getEvaluationPartialAnswer(workshop_id) {
    const api =
      url +
      `/participants/evaluations/${workshop_id}/answer`;
  
    return await participantInstance
      .get(api)
      .then((response) => {        
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  }

  // call the api for update Evaluation answering page number.
  async function UpdateEvaluationAnswerPage(workshop_id, data) {
      const api =
        url +
        `/participants/evaluations/${workshop_id}/page`;
    
      return await participantInstance
        .put(api, data)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error.response;
        });
    }

 // call the api for add Followup Partial answer
 async function addFollowupPartialAnswer(followup_id, data) {
  const api =
    url +
    `/participants/followups/${followup_id}/answer-save`;

  return await participantInstance
    .post(api, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

 //api for getting followup Partial answeres
 async function getFollowupPartialAnswer(followup_id) {
  const api =
    url +
    `/participants/followups/${followup_id}/answer`;

  return await participantInstance
    .get(api)
    .then((response) => {        
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

// call the api for update followup answering page number.
async function UpdateFollowupAnswerPage(followup_id, data) {
  const api =
    url +
    `/participants/followups/${followup_id}/page`;

  return await participantInstance
    .put(api, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

export const dashboardDetailsService = {
  getInventoryDetails,
  addInventoryAnswer,
  getInventoryAnswer,
  getEvaluationDetails,
  addEvaluationAnswer,
  getEvaluationAnswer,
  getFollowupDetails,
  addFollowupAnswer,
  getFollowupAnswer,
  addInventorySteps,
  updateInventorychecklist,
  getInventorychecklist,
  PostResponseLogs,
  addInventoryPartialAnswers,
  getInventoryPartialAnswers,
  addEvaluationPartialAnswer,
  getEvaluationPartialAnswer,
  UpdateEvaluationAnswerPage,
  addFollowupPartialAnswer,
  getFollowupPartialAnswer,
  UpdateFollowupAnswerPage,
};
